module.exports = __webpack_public_path__ + "static/media/01.42aa95bf.jpg";